var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"myChartTitle",staticStyle:{"text-align":"center","height":"16px","font-weight":"600","font-size":"14px","line-height":"16px"}},[_vm._v(_vm._s(_vm.config.title))]),_c('canvas',{ref:"myChart"})])}
var staticRenderFns = []

export { render, staticRenderFns }